module.exports = __webpack_public_path__ + "static/media/explain.cf99a56c.png";